import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

// Type definitions
interface Athlete {
  id: string;
  name?: string;
  [key: string]: unknown;
}

interface AthleteState {
  athletesList: Athlete[];
  isSelected: boolean;
  allAthletes: Athlete[];
}

const initialState: AthleteState = {
  athletesList: [],
  isSelected: false,
  allAthletes: [],
};

const athleteSlice = createSlice({
  name: "athlete",
  initialState,
  reducers: {
    setAthletesList: (state, action) => {
      state.athletesList = action.payload;
    },
    setIsAthleteSelected: (state, action) => {
      state.isSelected = action.payload;
    },
    setAllAthletes: (state, action) => {
      state.allAthletes = action.payload;
    },
  },
});

export const { setAthletesList, setIsAthleteSelected, setAllAthletes } =
  athleteSlice.actions;

// <-- selector to “get” membershipDetails -->
export const selectAthletesList = (state: RootState) =>
  state.athlete.athletesList;

// <-- selector to “get” membershipDetails -->
export const selectIsAthleteSelected = (state: RootState) =>
  state.athlete.isSelected;

// <-- selector to “get”  -->
export const selectAllAthletes = (state: RootState) =>
  state.athlete.allAthletes;

export default athleteSlice.reducer;
